import { Module } from 'vuex';
import IRootState from '../../types/IRootState';
import UiState from './types/UiState';
import mutations from './mutations';

const uiStore: Module<UiState, IRootState> = {
  namespaced: true,
  state: {
    overlay: false,
    loader: true,
    sidebar: false,
    delay: 3,
  },
  mutations,
};

export default uiStore;
